module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/typography/table-responsive/table-responsive.component.scss
// module id = ./src/app/features/typography/table-responsive/table-responsive.component.scss
// module chunks = main